import { Button, Modal, Text } from "@alpacahq/ui/old";

import type { AcatsTransfer } from "~/v2/api/rest/acats";

export interface CannotStartTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
  transfer: AcatsTransfer;
}

export const CannotStartTransferModal = ({
  isOpen,
  onClose,
  transfer,
}: CannotStartTransferModalProps) => {
  return (
    <Modal
      title="Cannot Start PortfolioTransfer"
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="flex flex-col gap-4 text-gray-700">
        <Text>You have ongoing Transfer out from your Alpaca account:</Text>
        <div className="flex flex-col gap-2 rounded bg-cool-gray-50 p-2">
          <div className="flex items-center justify-between gap-4">
            <Text>Broker Name</Text>
            <Text className="font-medium">{transfer.contra_broker_name}</Text>
          </div>
          <div className="flex items-center justify-between gap-4">
            <Text>Account Type</Text>
            <Text className="font-medium">{transfer.account_type}</Text>
          </div>
          <div className="flex items-center justify-between gap-4">
            <Text>Account Number</Text>
            <Text className="font-medium">{transfer.account_number}</Text>
          </div>
          <div className="flex items-center justify-between gap-4">
            <Text>Transfer Date</Text>
            <Text className="font-medium">{transfer.created_at}</Text>
          </div>
        </div>
        <Text>
          Please wait till the outgoing transfer to be completed. More
          questions? Contact{" "}
          <a
            href="mailto:support@alpaca.markets"
            className="text-indigo-500 underline"
          >
            support@alpaca.markets
          </a>
          .
        </Text>
        <div className="flex items-center justify-end gap-2">
          <Button variant="v2/stroke" onClick={onClose}>
            Back to Transfer
          </Button>
          <Button variant="v2/filled" onClick={onClose}>
            Stay on this Page
          </Button>
        </div>
      </div>
    </Modal>
  );
};
